import React from 'react';
import classnames from 'classnames';
/**
 * SoopUiDateInput 컴포넌트
 * @desc 선택한 날짜 보여주는 input 요소
 * @param {Object} props - 컴포넌트의 props
 * @param {Object} props.dateRange - dateRange 시작, 종료일자
 * @param {string} props.selectedPeriod - 시작 + 종료 일자
 * @param {Function} [props.handleCalendarOpen] - 캘린더 여는 실행 함수
 * @returns {JSX.Element} 날짜 인풋 렌더링하는 JSX 요소
 * // TODO example 요소 추가하기
*/

const SoopUiDateInput = ({
  isCalendarActive,
  handleCalendarOpen,
  selectedPeriod,
}) => {

  return (
    <>
      <div
        className={classnames('inp', {
          on: isCalendarActive,
        })}
        onClick={handleCalendarOpen}>
        <input
          type='text'
          placeholder='기간을 선택해 주세요.'
          value={selectedPeriod}
          readOnly
        />
      </div>
    </>
  );
};

export default React.memo(SoopUiDateInput);
